import { render, staticRenderFns } from "./buy-invoices-table.vue?vue&type=template&id=e5cd5f24"
import script from "./buy-invoices-table.vue?vue&type=script&lang=js"
export * from "./buy-invoices-table.vue?vue&type=script&lang=js"
import style0 from "./buy-invoices-table.vue?vue&type=style&index=0&id=e5cd5f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports